import styled from '@emotion/styled'
import { css } from '@emotion/react'

const MUTED_TEXT_COLOR = '#9eacb0'

// Row measurements reused by desktop rows, mobile cards, and empty states.
export const ROW_METRICS = Object.freeze({
  radius: '10px',
  minHeight: '56px',
  blockPadding: '8px',
  inlinePadding: '24px',
  gap: '10px',
})

// Shared border for desktop rows, mobile cards, and empty states.
export const rowBorder = p => css`
  box-sizing: border-box;
  border: 2px solid ${p.theme.primaryLighter ?? '#d4ebf2'};
`

// Style the row-name button as a text link.
export const rowNameButton = p => css`
  min-width: 0;
  padding: 0;
  border: none;
  background: none;
  outline: none;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${p.theme.primaryColor};
    outline-offset: 2px;
    text-decoration: underline;
  }
`

export const rowFill = p => (p.$muted ? (p.theme.primaryLight ?? '#f0f4f5') : '#ffffff')

export const mutedText = p => (p.$muted ? MUTED_TEXT_COLOR : p.theme.mediumGray)

export const mutedTitleText = p => (p.$muted ? MUTED_TEXT_COLOR : p.theme.darkestGray)

// Use the container's gap to space different row components consistently.
export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${p => p.$gap};
`

export const firstColumn = columns => columns[0]

/** Builds the column layout shared by desktop headers and rows, with an optional trailing column. */
export const gridTemplate = (columns, { hasTrailing = false, trailingWidth } = {}) => {
  const tracks = columns.map((c, index) => `minmax(0, ${c.fr ?? (index === 0 ? 2 : 1)}fr)`)
  return hasTrailing ? [...tracks, trailingWidth].join(' ') : tracks.join(' ')
}

export const hasTrailing = rows => rows.some(row => row.trailing)
